import { useApiRequest } from "@hooks/use-api-request";
import { HttpMethod } from "@lib/http.helpers";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const PREFERENCES_QUERY_KEY = ["user-preferences"];

export const useUserPreferences = () => {
  const queryFn = useApiRequest({
    url: "users/me/preferences",
    method: HttpMethod.Get,
  });

  return useQuery({
    queryKey: PREFERENCES_QUERY_KEY,
    queryFn,
  });
};

export const useUpdateUserPreferences = () => {
  const queryClient = useQueryClient();
  const mutationFn = useApiRequest({
    url: "users/me/preferences",
    method: HttpMethod.Put,
    useResponseData: false,
  });

  return useMutation({
    mutationKey: ["update-user-preferences"],
    mutationFn: ({ classroomId }) =>
      mutationFn({ data: { classroom_id: classroomId } }),
    onSuccess: (_data, { classroomId }) => {
      queryClient.setQueryData(PREFERENCES_QUERY_KEY, (current) => ({
        ...current,
        classroomId,
      }));
      queryClient.invalidateQueries({
        queryKey: PREFERENCES_QUERY_KEY,
        exact: true,
      });
    },
  });
};

export { PREFERENCES_QUERY_KEY };
